import React from 'react'
import nl_flag from '../img/nl-flag.png'
import uk_flag from '../img/uk-flag.png'
import ReactDOM from 'react-dom';
import App from '../App';
import AppEng from '../AppEng';


export class Flags extends React.PureComponent {
    state = {
        lang : 'dutch'
    }
    handleDutchLang = () => {
        ReactDOM.render(<App />, document.getElementById('root'));
    }
    handleEngLang= () => {
        ReactDOM.render(<AppEng />, document.getElementById('root'));
    }

    render() {

        const flagStyle = {
            width:'20px',
            marginLeft:'10px',
            cursor:'pointer'
          }
  
     
        return (
            <div className="d-flex">
                <li onClick={this.handleDutchLang} className="nav-item"><img style={flagStyle} src={nl_flag} alt="flag of The Netherlands"></img></li>
                <li onClick={this.handleEngLang} className="nav-item"><img style={flagStyle} src={uk_flag} alt="flag of The UK"></img></li>
            </div>
               
        )
    }
}
export default React.memo(Flags)
